import { Outlet, ScrollRestoration } from 'react-router-dom';

export function RootLayout() {
	return (
		<>
			<ScrollRestoration />
			<Outlet />
		</>
	);
}
